<template>
  <v-card elevation="2" outlined shaped tile class="my-4">
    <v-card-title>
      <div @click="expand = !expand" :style="{ cursor: 'pointer' }">Hero Banners</div>
      <div class="ml-2">
        <v-btn icon color="green" @click="moveUp(section.id)">
          <v-icon>mdi-arrow-up-bold-box</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="moveDown(section.id)">
          <v-icon>mdi-arrow-down-bold-box</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="expand">
      <div>ID: {{ section.id }}</div>
      <div>Type: {{ section.type }}</div>
      <div>Sort Order: {{ section.sort_order }}</div>
      <div>Children Count: {{ section.children.length }}</div>
    </v-card-subtitle>
    <v-card-text v-if="expand">
      <div class="d-flex flex-wrap">
        <v-flex md6 xs12 v-for="child in children" :key="child.id">
          <home-feed-hero-child :child="child" :onChildChange="onChildChange" />
        </v-flex>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import HomeFeedHeroChild from './HomeFeedHeroChild.vue';
export default Vue.extend({
  components: {
    HomeFeedHeroChild,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    moveUp: {
      type: Function,
      required: true,
    },
    moveDown: {
      type: Function,
      required: true,
    },
    onChildChange: {
      type: Function,
      required: true,
    },
  },
  computed: {
    children() {
      const children = this.section.children || [];
      children.push({
        type: 'hero',
        section_id: this.section.id,
      });
      return children;
    },
  },
  data: () => ({
    expand: false,
  }),
  methods: {
    toggleExpand() {
      this.expand = !this.expand;
    },
  },
});
</script>

<style scoped></style>
